import _ from 'lodash';
import { AuthHelper } from '../types/auth-helper-types';
import * as ApiRequests from '../api/requests';
import { DomainResponse, makeOkDomainResponse } from '../data/domain/domain-response';
import { Data, isDataLoaded, makeErrorData, makeLoadedData } from '../types/data-providers';
import { OrganizationInfo } from '../types';

type Organization = {
    id: string;
    name: string;
    address: string;
};


export type AppData = {
    organizations: DomainResponse<{ [k: string]: DomainResponse<Organization> }>;
};

// TODO: move to a manager
type GetOrganizationsResult = DomainResponse<OrganizationInfo[]>;

const getOrganizations = async (
    authHelper: AuthHelper,
    userId: string
): Promise<GetOrganizationsResult> => {
    
    const result = await ApiRequests.getOrganizations({ userId }, { authHelper });
    if (result.ok) {
        
        return {
            ok: true,
            value: result.response.data.organizations,
        };
    }
   
    return { ok: false, message: ApiRequests.extractErrorCodeWithMessage(result.response) };
};

const loadDataForUser = async (
    authHelper: AuthHelper,
    userId: string
): Promise<DomainResponse<AppData>> => {
    const organizationsResult = await getOrganizations(authHelper, userId);

    if (!organizationsResult.ok) {
        return organizationsResult;
    }

    const emptyOrganizations: { [k: string]: DomainResponse<Organization> } = {};

    const organizations = organizationsResult.value.reduce((memo, org) => {
        memo[org.organizationId] = makeOkDomainResponse({
            id: org.organizationId,
            name: org.organizationName,
            address: org.address,
        });
        return memo;
    }, emptyOrganizations);

    return makeOkDomainResponse({
        organizations: makeOkDomainResponse(organizations),
    });
};

const getOrganization = (appData: Data<AppData>, organizationId: string | undefined): Data<Organization> => {
    if (!isDataLoaded(appData)) {
        return appData;
    }

    if (!appData.value.organizations.ok) {
        return makeErrorData(appData.value.organizations.message || 'Organization not found');
    }

    const organizations = appData.value.organizations.value;

    const organization = organizationId ? organizations[organizationId] : _.values(organizations)[0];

    if (!organization) return makeErrorData('Organization not found');

    if (!organization.ok) {
        return makeErrorData(organization.message || 'Organization not found');
    }
    return makeLoadedData(organization.value);
};

export const AppDataLoader = {
    loadDataForUser,
    getOrganization,
};
